// extracted by mini-css-extract-plugin
export var authForm = "SaaSAuthModal-module--authForm--4820d";
export var authModal = "SaaSAuthModal-module--authModal--c948b";
export var cMarginTop = "SaaSAuthModal-module--c-margin-top--3e318";
export var cPadding = "SaaSAuthModal-module--c-padding--390a0";
export var cPaddingBottom = "SaaSAuthModal-module--c-padding-bottom--79d4d";
export var cPaddingTop = "SaaSAuthModal-module--c-padding-top--03850";
export var captchaWrapper = "SaaSAuthModal-module--captchaWrapper--19161";
export var closeButton = "SaaSAuthModal-module--closeButton--17f30";
export var divider = "SaaSAuthModal-module--divider--72c67";
export var errorText = "SaaSAuthModal-module--errorText--96de5";
export var eyeButton = "SaaSAuthModal-module--eyeButton--fb42c";
export var forgotPasswordLink = "SaaSAuthModal-module--forgotPasswordLink--cebc4";
export var googleFallback = "SaaSAuthModal-module--googleFallback--5bfee";
export var googleWrapper = "SaaSAuthModal-module--googleWrapper--8079d";
export var helperText = "SaaSAuthModal-module--helperText--e9e23";
export var maxWidth = "SaaSAuthModal-module--max-width--d56ee";
export var modalOverlay = "SaaSAuthModal-module--modalOverlay--8a56a";
export var modeLabel = "SaaSAuthModal-module--modeLabel--17ce4";
export var passwordInputWrapper = "SaaSAuthModal-module--passwordInputWrapper--b9334";
export var submitButton = "SaaSAuthModal-module--submitButton--c3ee4";
export var switchButton = "SaaSAuthModal-module--switchButton--24664";